__turbopack_context__.v({
  "card": "StatCards-module__JCgqlW__card",
  "grid": "StatCards-module__JCgqlW__grid",
  "label": "StatCards-module__JCgqlW__label",
  "value": "StatCards-module__JCgqlW__value",
});
